const DailyCountsObject = ({ count = null, timestamp = '', inquiryPercent = null }) => ({
  count: count && Number(count),
  timestamp: String(timestamp),
  inquiryPercent: Number(inquiryPercent),
});

const PageViews = ({ marketAverage = {}, property = {}, updatedTimestamp = 0, hasEnoughComps = false, days = 0 }) => ({
  marketAverage: DailyCountsObject(marketAverage),
  property: DailyCountsObject(property),
  updatedTimestamp: String(updatedTimestamp),
  hasEnoughComps: Boolean(hasEnoughComps),
  days: Number(days),
});

export default PageViews;

export type PageViewsProps = ReturnType<typeof PageViews>;
